import { SwallowedEntityMetrics, SwallowedMap } from './utils';

/**
 * @param {Object} src entities to copy
 * @returns {Object}
 */
export default function makeEntities(src) {
  const entities = src?.entities;
  const out = {};
  out.groups = {};
  out.roles = {};
  out.activities = {};
  out.people = {};

  if (!entities || typeof entities !== 'object') {
    return out;
  }

  // groups
  if (entities.groups && typeof entities.groups === 'object') {
    for (const key in entities.groups) {
      const group = entities.groups[key];
      out.groups[key] = {
        uuid: group.uuid,
        group_uuid: group.group_uuid,
        lead_uuid: group.lead_uuid,
        name: group.name,
        objective: group.objective,
        properties: [...(group.properties ?? [])],
        tags: [...(group.tags ?? [])],
        order: group.order,
        created_at: group.created_at,
        updated_at: group.updated_at,

        /** @retained */
        __layer: group.__layer,

        /** @filters */
        __percentage: 100,

        /** @deprecated */
        __tags_summarised: SwallowedMap,
      };
    }
  }

  // roles
  if (entities.roles && typeof entities.roles === 'object') {
    for (const key in entities.roles) {
      const role = entities.roles[key];
      out.roles[key] = {
        uuid: role.uuid,
        group_uuid: role.group_uuid ?? null,
        parent_uuid: role.parent_uuid ?? null,
        person_uuid: role.person_uuid ?? null,
        external_id: role.external_id ?? '',
        is_manager: role.is_manager ?? false,
        title: role.title,
        fte: role.fte,
        budget: Number(role.budget) || 0,
        properties: [...(role.properties ?? [])],
        tags: [...(role.tags ?? [])],
        skills: [...(role.skills ?? [])],
        order: role.order,
        created_at: role.created_at,
        updated_at: role.updated_at,

        /** @retained */
        __layer: role.__layer,

        /** @todo */
        __tags_summarised: SwallowedMap,
        __percentage: 100,
      };
    }
  }

  // activities
  if (entities.activities && typeof entities.activities === 'object') {
    for (const key in entities.activities) {
      const activity = entities.activities[key];
      out.activities[key] = {
        uuid: activity.uuid,
        library_uuid: activity.library_uuid,
        owner_uuid: activity.owner_uuid,
        owner_type: activity.owner_type,
        properties: [...(activity.properties ?? [])],
        tags: [...(activity.tags ?? [])],
        hours: activity.hours,
        order: activity.order,
        created_at: activity.created_at,
        updated_at: activity.updated_at,
        disabled_at: activity.disabled_at,

        /** @todo */
        __color: activity.__color,
      };
    }
  }

  // people
  if (entities.people && typeof entities.people === 'object') {
    for (const key in entities.people) {
      const person = entities.people[key];
      out.people[key] = {
        uuid: person.uuid,
        first_name: person.first_name,
        last_name: person.last_name,
        avatar: person.avatar,

        /** @todo */
        __metrics: SwallowedEntityMetrics,
        __pathname: person.__pathname,
      };
    }
  }

  return out;
}
